/**
 * Media Query Helper, version 20150224
 * by Nils Magnus Englund <nme@stepone.no>
 *
 * Using optimizedResize code from https://developer.mozilla.org/en-US/docs/Web/Events/resize
 */

type MediaPrefix = '' | 'xs' | 'sm' | 'md' | 'lg';

let thresholds: any;
let trigger: any;
let running = false;
let previous_threshold: MediaPrefix | null = null;

function resize() {
  if (!running) {
    running = true;
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(compare);
    } else {
      setTimeout(compare, 40);
    }
  }
}

function compare() {
  var current_threshold = getCurrentThreshold();
  if (previous_threshold != current_threshold) {
    trigger(current_threshold, previous_threshold);
  }
  previous_threshold = current_threshold;
  running = false;
}

function getCurrentThreshold(): MediaPrefix {
  const width = document.body.clientWidth;
  let threshold: MediaPrefix = '';
  for (let x = 0, t = thresholds.length; x < t; x++) {
    const th = thresholds[x];
    if (!th.max || width <= th.max) {
      threshold = th.prefix;
      return threshold;
    }
  }
  return threshold;
}

const defaultThresholds = [
  // Default thresholds from Bootstrap 3
  { prefix: 'xs', max: 768 },
  { prefix: 'sm', max: 991 },
  { prefix: 'md', max: 1199 },
  { prefix: 'lg' },
];

export function watch(opts: any) {
  thresholds = opts.thresholds || defaultThresholds;

  if (typeof opts.trigger === 'function') {
    trigger = opts.trigger;
    window.addEventListener('resize', resize);
  }
}
